// Generated by CoffeeScript 2.7.0
var CascadedSelectListItem;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import EditCascadedSelectModal from './cascaded_selects_modal/edit_cascaded_selects_modal.js';

export default CascadedSelectListItem = Vue.extend({
  components: {
    Popover: Popover
  },
  props: {
    cascadedSelectOption: {
      type: Object
    },
    selectedId: {
      type: [String, Number]
    },
    resourceUrl: {
      type: String
    }
  },
  data: function() {
    return {
      showPopover: false
    };
  },
  template: `<div class="list-item node-wrapper justify-between"
     :class="{ selected: selected }"
     @click="cascadedSelectChange">
  <div class="name">
    <span>{{ cascadedSelectOption.name }}</span>
  </div>
  <Popover position='bottom right'
           size="small"
           @beforeOpen="popoverBeforeOpen"
           @beforeClose="popoverBeforeClose"
           ref="popoverRef">
    <template slot="trigger">
      <div :class='nodeClass' @click.stop="togglePopover">
        <i class="slp-ellipsis-circle-o"></i>
      </div>
    </template>
    <div class="list" slot="content">
      <div class="list-item" @click.stop="openCascadedSelectModalFunc">
        <i class="slp-pencil"></i>
        <span class="ml-2">编辑级联选择</span>
      </div>
      <div class="list-item"
           v-if="!cascadedSelectOption.locked"
           @click.stop="deleteCascadedSelect">
        <i class="slp-trash"></i>
        <span class="ml-2">删除级联选择</span>
      </div>
    </div>
  </Popover>
</div>`,
  computed: {
    selected: function() {
      return parseInt(this.selectedId) === this.cascadedSelectOption.id;
    },
    nodeClass: function() {
      return {
        "node-hover": !this.showPopover,
        "node-show": this.showPopover
      };
    }
  },
  methods: {
    cascadedSelectChange: function() {
      return this.$emit('selectedCascadedSelectChange', this.cascadedSelectOption.id);
    },
    popoverBeforeOpen: function() {
      return this.showPopover = true;
    },
    popoverBeforeClose: function() {
      return this.showPopover = false;
    },
    togglePopover: function(event) {
      return this.$refs.popoverRef.togglePopover();
    },
    openCascadedSelectModalFunc: function() {
      this.togglePopover();
      return new EditCascadedSelectModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-cascaded-select-modal'),
        propsData: {
          title: '编辑级联选择',
          initialCascadedSelect: this.cascadedSelectOption,
          callback: (cascaded_select) => {
            return this.editCascadedSelectFunc(cascaded_select);
          }
        }
      });
    },
    editCascadedSelectFunc: function(cascaded_select) {
      var data;
      data = {
        cascaded_select: {
          labels: cascaded_select.labels,
          name: cascaded_select.name
        }
      };
      return Skylark.Libs.Ajax.put(`${this.resourceUrl}/${cascaded_select.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: data,
        success: (data) => {
          Skylark.Bridge.newAlertify('编辑成功', {
            type: 'success'
          });
          return this.$emit('cascadedSelectChanged', cascaded_select);
        },
        error: function(xhr, status, errors) {
          return Skylark.Bridge.newAlertify(errors.join('，'), {
            type: 'error'
          });
        }
      });
    },
    deleteCascadedSelect: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '是否删除此级联选择',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`${this.resourceUrl}/${this.cascadedSelectOption.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            this.$emit('deletedCascadedSelect', this.cascadedSelectOption.id);
            return Skylark.Bridge.newAlertify('删除级联选择成功', {
              type: 'success'
            });
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除级联选择失败', {
              type: 'error'
            });
          }
        });
      });
    }
  }
});
